import { owner } from "./owner";
import { employee } from "./employee";
export var business = {
    owner: owner,
    employee: employee,
};
